import { OrganizedTopic } from 'types';

export default (organizedTopic: OrganizedTopic, slug: string): string[] => {
  let findingParentTopicHasCompleted = false;
  let topicSlugs: string[] = [slug];
  let lastFoundTopicSlug = slug;
  const topicsByParentSlug = organizedTopic.topicsByParentSlug;
  const topicsByParentSlugKeys = Object.keys(topicsByParentSlug);

  while (!findingParentTopicHasCompleted) {
    let parentTopicSlug = '';

    topicsByParentSlugKeys.forEach((key) => {
      const parentTopic = topicsByParentSlug[key].find(
        (topic) => topic.slug === lastFoundTopicSlug
      );
      if (!!parentTopic) {
        parentTopicSlug = key;
      }
    });

    if (
      !!parentTopicSlug &&
      !topicSlugs.includes(parentTopicSlug) &&
      parentTopicSlug !== '/root'
    ) {
      topicSlugs = [parentTopicSlug].concat(topicSlugs);
      lastFoundTopicSlug = parentTopicSlug;
    } else {
      findingParentTopicHasCompleted = true;
    }
  }

  return topicSlugs.map((slug) => {
    if (slug[0] === '/') {
      return slug.slice(1);
    }

    return slug;
  });
};
